import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex mb-2" }
const _hoisted_2 = { class: "mx-3" }
const _hoisted_3 = { class: "text-color-secondary text-base" }
const _hoisted_4 = ["textContent"]

import { computed, toRefs } from 'vue';
import { storeToRefs } from 'pinia';
import { useReviewReportStore } from '@/store';

interface Props {
  title: string;
  tooltip: string;
  icon: string;
  total: number;
  color: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewReportTrackTotal',
  props: {
    title: { default: '' },
    tooltip: { default: '' },
    icon: { default: 'calendar_today' },
    total: { default: 0 },
    color: { default: 'blue' }
  },
  setup(__props: any) {

const reviewReportStore = useReviewReportStore();
const { track } = storeToRefs(reviewReportStore);

const props = __props;

const { title, tooltip, icon, total, color } = toRefs(props);

const formatTotal = computed(() => new Intl.NumberFormat().format(total.value));

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      name: _unref(icon),
      class: _normalizeClass(`text-color-${_unref(color)} text-4xl p-2 bg-${_unref(color)}-light border-round align-self-start`)
    }, null, 8, ["name", "class"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(title)), 1),
      (_unref(track).loading)
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            height: "3rem",
            class: "mt-1"
          }))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(`text-color-${_unref(color)}-dark text-5xl font-bold`),
            textContent: _toDisplayString(formatTotal.value)
          }, null, 10, _hoisted_4))
    ]),
    _withDirectives(_createVNode(_component_Icon, {
      name: "info",
      class: "text-gray-400 text-base cursor-pointer align-self-start"
    }, null, 512), [
      [
        _directive_tooltip,
        `${_unref(tooltip)}`,
        void 0,
        { bottom: true }
      ]
    ])
  ]))
}
}

})